import {NoteBookReducer} from './NoteBookReducer';
import {createStore, applyMiddleware} from 'redux';
import logger from 'redux-logger';
import {combineReducers} from 'redux';
import {INITIAL_STATE} from './InitialState';
import {SimulationLevelReducer} from './SimulationLevelReducer';
import {SlideOneReducer} from './SlideOneReducer';
import {SlideTwoReducer} from './SlideTwoReducer';
import {CSCQReducer} from './CSCQReducer';
import {OEQReducer} from './OEQReducer';
import {NEQReducer} from './NEQReducer';
import {DDQReducer} from './DDQReducer';
import {DNDQReducer} from './DNDQReducer';
import {MSCQReducer} from './MSCQReducer';

import {SlideThreeReducer} from './SlideThreeReducer';

// TODO
import {GelDragDropQuestionReducer} from './GelDragDropQuestionReducer';

// -- Remove and clean out this state props -- //
import {ProtocolReducer} from './ProtocolReducer';
// -- -- //
import {ModalReducer} from './ModalReducer';
import {UndoReducer} from './UndoReducer';

import {PipetteReducer} from './PipetteReducer';
import {TipBoxReducer} from './TipBoxReducer';
import {TrashReducer} from './TrashReducer';
import {SolutionReducer} from './SolutionReducer';
import {MicrocentrifugeReducer} from './MicrocentrifugeReducer';
import {IceBucketReducer} from './IceBucketReducer';
import {ThermocyclerReducer} from './ThermocyclerReducer';
import {HeatBlockReducer} from './HeatBlockReducer';
import {PosterReducer} from './PosterReducer';

import {PageTourReducer} from './PageTourReducer';

const notebookReducer = (state = INITIAL_STATE.notebook, action) => {
  state = NoteBookReducer(state, action);
  state = SimulationLevelReducer(state, action);
  state = SlideOneReducer(state, action);
  state = SlideTwoReducer(state, action);
  state = CSCQReducer(state, action);
  state = OEQReducer(state, action);
  state = NEQReducer(state, action);
  state = DDQReducer(state, action);
  state = DNDQReducer(state, action);
  state = MSCQReducer(state, action);
  state = SlideThreeReducer(state, action);

  state = GelDragDropQuestionReducer(state, action);

  state = ProtocolReducer(state, action);
  state = ModalReducer(state, action);
  state = UndoReducer(state, action);

  state = PipetteReducer(state, action);
  state = TipBoxReducer(state, action);
  state = TrashReducer(state, action);
  state = SolutionReducer(state, action);
  state = MicrocentrifugeReducer(state, action);
  state = IceBucketReducer(state, action);
  state = ThermocyclerReducer(state, action);
  state = PosterReducer(state, action);
  state = PageTourReducer(state, action);

  return {...state};
};

const rootReducer = combineReducers({
  notebook: notebookReducer
});

export const Store = createStore(rootReducer, applyMiddleware(logger));
